module.exports = {
  getFieldType: (field) => field.typeText
    ?? field.typeSelect
    ?? field.typeDateTime
    ?? field.typeCheckbox,

  getRequiredField: (label, isRequired) => (isRequired ? `${label}*` : label),

};
